import api from '../../../../App/socket';
import { PURCHASING_API } from '../../../../../common/constants/api';
import config from '../../../../../config/sbf_config';
import { getErrorMessage } from '../../../../../shared/helpers';
import { leadsServiceApi } from '../../../../../infra/purchasingApi.service';

export const getBlemishReport = async (lead_id, ...field) => {
    if (config.featureToggles.leadBlemishReport) {
        if (field.includes('rag_rating')) {
            try {
                const res = await leadsServiceApi({
                    method: 'get',
                    url: `${PURCHASING_API.LEADS}/${lead_id}/lead-blemish-report/rag-rating`,
                });

                return {
                    result: true,
                    options: { rag_rating: res.data?.ragRating },
                };
            } catch (e) {
                return {
                    msg: getErrorMessage(e),
                    error: e,
                };
            }
        }

        try {
            const res = await leadsServiceApi({
                method: 'get',
                url: `${PURCHASING_API.LEADS}/${lead_id}/lead-blemish-report`,
            });

            return {
                result: true,
                options: res.data,
            };
        } catch (e) {
            return {
                msg: getErrorMessage(e),
                error: e,
            };
        }
    }

    return api.send({
        api: 'db',
        model: 'Lead_blemish_report',
        action: 'Read',
        options: {
            attributes: field.length ? field : 'all',
            limit: 1,
            where: {
                ref_lead: lead_id,
            },
        },
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/leads_questions/get_blemish_report_request.js